import React, { useState, useRef } from 'react';
import cx from 'clsx';
import { Portal } from 'react-portal';
import ArrowDownward from '../Icons/ArrowDownward';
import ArrowRight from '../Icons/ArrowRight';
import { sendEvent } from '../../utils/ga';
import Link from '../Link';
import * as styles from './style.module.scss';
import * as themeStyles from '../../assets/theme.module.scss';
import {
    genCategoryUrl, genProductUrl, allCategoriesUri,
} from '../../utils/urls';

const NestedDropdown = ({ className, categories }) => {
    const [dropdownStyle, setShowDropdown] = useState({});
    const linkRef = useRef(null);
    function onShowDropdown() {
        const { left, top } = linkRef.current.getBoundingClientRect();
        setShowDropdown({
            left: `${left + 2}px`,
            top: `${top + 50}px`,
            display: 'block',
        });
    }

    function onMouseLeave() {
        setShowDropdown({
            display: 'none',
        });
    }

    function onClickNestedLink(productName) {
        sendEvent('Nav Nested Link', 'click', productName);
    }

    function onClickNavLink(category) {
        sendEvent('Nav Link', 'click', category);
    }

    return (
        <>
            <Link linkRef={linkRef} to={allCategoriesUri} className={cx(styles.topAnchor, className)} onMouseEnter={onShowDropdown}>
                產品介紹
                <ArrowDownward />
            </Link>
            <Portal>
                <ul onMouseLeave={onMouseLeave} style={dropdownStyle} className={cx(styles.dropdownWrapper, styles.topLevelMenu)}>
                    {categories.map((item) => (
                        <li className={cx(styles.dropdownItem, themeStyles.positionRelative)}>
                            <Link to={genCategoryUrl(item.url)} className={styles.dropdownAnchor} onClick={() => onClickNavLink(item.name)}>
                                <span>{item.name}</span>
                                {item.products ? <ArrowRight /> : null}
                            </Link>
                            <ul className={cx(styles.dropdownWrapper, styles.subMenu)}>
                                {item.products && item.products.map((product) => (
                                    <li className={styles.dropdownItem}>
                                        <Link to={genProductUrl(item.url, product.url)} onClick={() => onClickNestedLink(product.name)}>{product.name}</Link>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </Portal>
        </>
    );
};
export default NestedDropdown;
